module.exports = __webpack_public_path__ + "assets/img/page-title-8ab6c0a6.png";